export enum HVSubstationSetupErrorCode {
  PanelIdExistsOnActiveWorkflowException = 1,
  AssetIdDoesNotBelongToAPanelException = 2,
  ActiveWorkOrderExistsOnHVSubstationException = 3,
  HVSubstationDoesNotExistException = 4,
  AssetIsNotAHVSubstationException = 5,
  AssetExistsOnActiveWorkflowException = 6,
}
